require('./bootstrap');

window.Tagify = require('@yaireo/tagify')
window.Vue = require('vue')
window.Sortable = require('sortablejs').default
window.draggable = require('vuedraggable')
window.jsPDF = require('jspdf').default